import { useEffect, useRef } from "react";
import "./fstyle.css";

// Function to convert YouTube URL to embed format
const getEmbedUrl = (url) => {
  // Check for YouTube URLs
  const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (youtubeMatch) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`;
  }

  // Check for Vimeo URLs
  const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  }

  // Return the original URL if it's not recognized
  return url;

};

const VideoLightbox = ({ videoUrl, onClose }) => {
  const closeRef = useRef(null);
  const overlayRef = useRef(null);
  const triggerRef = useRef(document.activeElement);

  useEffect(() => {
    // Focus close button on open.
    if (closeRef.current) {
      closeRef.current.focus();
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
        return;
      }

      // Trap focus inside the dialog.
      if (event.key === "Tab" && overlayRef.current) {
        const focusable = overlayRef.current.querySelectorAll(
          'button, iframe, [tabindex]:not([tabindex="-1"])'
        );
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === first) {
            event.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      // Restore focus to trigger element.
      if (triggerRef.current && triggerRef.current.focus) {
        triggerRef.current.focus();
      }
    };
  }, [onClose]);

  // Get embed URL for YouTube videos
  const embedUrl = getEmbedUrl(videoUrl);

  return (
    <div
      className="video-lightbox-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Video preview"
      ref={overlayRef}
      onClick={onClose}
    >
      <div className="video-lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="close-button"
          onClick={onClose}
          ref={closeRef}
          aria-label="Close video preview"
        >
          &times;
        </button>
        <iframe
          src={embedUrl}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Video Preview"
          className="video-iframe"
        />
      </div>
    </div>
  );
};

export default VideoLightbox;
